import React, { Component } from 'react';
import PropTypes from 'prop-types';
import $j from 'jquery';

export default class CustomDotDotDot extends Component {
  componentDidMount(props) {
    const elem = $j(this.cdRef);
    // console.log('props:', props, this.props);
    this.cdJQRef = null;
    if (elem && elem.dotdotdot) {
      this.cdJQRef = elem
        .dotdotdot({
          height: this.props.height,
          keep: this.props.keep,
          ellipsis: '\u2026 '
        })
        .data('dotdotdot');
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.comparer !== prevProps.comparer) {
      this.cdJQRef && this.cdJQRef.truncate && this.cdJQRef.truncate();
    }

    if (prevProps.height !== this.props.height) {
      const elem = $j(this.cdRef);
      // console.log('props:', props, this.props);
      this.cdJQRef = null;
      if (elem && elem.dotdotdot) {
        this.cdJQRef = elem
          .dotdotdot({
            height: this.props.height,
            keep: this.props.keep,
            ellipsis: '\u2026 '
          })
          .data('dotdotdot');
      }
    }
  }

  render() {
    return (
      <div className="customDotDotDotContainer" ref={ref => (this.cdRef = ref)}>
        {this.props.children}
      </div>
    );
  }
}

CustomDotDotDot.propTypes = {
  height: PropTypes.number,
  keep: PropTypes.string
};

CustomDotDotDot.defaultProps = {
  height: null,
  keep: null
};
